import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { GetIsStaff, GetIsStaffResponse } from '../api/dtos';
import { useGet } from '@ngt/forms';
import { useRegistrationYear } from './useRegistrationYear';

const getData = (response?: SWRResponse<GetIsStaffResponse, GetIsStaffResponse>) => response?.data?.isStaff;

const getError = (response?: SWRResponse<GetIsStaffResponse, GetIsStaffResponse>) => (response?.error ?? response?.data)?.responseStatus;

const getAdditionalState = (response?: SWRResponse<GetIsStaffResponse, GetIsStaffResponse>) => ({
    isStaff: response?.data?.isStaff,
    registered: response?.data?.registered
});

export const usePersonnelDetails = (firstName?: string, lastName?: string, configuration?: SWRConfiguration) => {
    const registrationYear = useRegistrationYear();

    const request = useMemo(() => {
        if (!firstName || !lastName) {
            return undefined;
        }
        
        return () => {
            return new GetIsStaff({firstName, lastName, registrationYear});
        };
    }, [firstName, lastName, registrationYear]);

    return useGet(request, { getData, getError, getAdditionalState}, configuration);
};

export default usePersonnelDetails;
